var DashPassStrings = {
    selfServeDpPageTitle: function () { return 'Maximize your budgets with DashPass'; },
    selfServeDpPageTitleActive: function () { return 'DashPass for Work'; },
    selfServeDpPageContent: function () {
        return 'DashPass gives you $0 delivery fee and reduced service fees on every eligible DoorDash order.';
    },
    activateButton: function () { return 'Activate DashPass'; },
    benefitSectionTitle: function () { return 'Benefits'; },
    benefitSectionFreeDelivery: function () {
        return '$0 delivery fee and reduced service fees on orders over $12.';
    },
    benefitSectionOrderAnyTime: function () {
        return 'Order any time, anywhere. No restrictions!';
    },
    benefitSectionSaveMoney: function () {
        return 'DashPass pays for itself in 2 orders on average.';
    },
    benefitSectionDpEligibleRestaurants: function () {
        return 'Choose from thousands of DashPass eligible restaurants. Look for the DashPass logo.';
    },
    howItWorksSectionTitle: function () { return 'How it works'; },
    howItWorksStepOne: function () { return 'Enable DashPass for employees.'; },
    howItWorksStepTwo: function () { return 'Add employees to the account.'; },
    howItWorksStepThree: function () {
        return 'Employees enjoy unlimited $0 delivery and reduced service fees on eligible orders.';
    },
    benefitActivationModalTitle: function () { return 'Activate DashPass for your employees'; },
    benefitActivationModalContent1Part1: function () { return 'You’ll activate DashPass for '; },
    benefitActivationModalContent1Part2: function (numEmployees) {
        return numEmployees + " " + (numEmployees === 1 ? 'employee' : 'employees');
    },
    benefitActivationModalContent1Part3: function () { return '. You’ll be charged '; },
    benefitActivationModalContent1Part4: function () { return '$9.99 a month'; },
    benefitActivationModalContent1Part5: function () {
        return ' for every employee on first day of the next month.';
    },
    benefitActivationModalContent2: function () {
        return "We will prorate the fee based on the days that DashPass was active this month.";
    },
    benefitActivationModalConfirmButton: function () { return 'Activate'; },
    benefitActivationModalCancelButton: function () { return 'Cancel'; },
    active: function () { return 'Active'; },
    activatedMessage: function () {
        return 'DashPass for Work has been activated for all eligible employees.';
    },
    infoBoxEmployeesDescription: function (numEmployees) {
        return "" + (numEmployees === 1 ? 'eligible employee' : 'eligible employees');
    },
    infoBoxPriceTitle: function () { return '$9.99'; },
    infoBoxPriceDescription: function () { return 'per employee per month'; },
    errorBannerTitle: function () { return 'We encountered an unexpected error'; },
    errorBannerMessagePart1: function () { return 'Try again or'; },
    errorBannerMessagePart2: function () { return 'contact support'; },
    errorBannerMessagePart3: function () { return 'for further assistance'; },
    addPaymentMethodWarningTitle: function () { return 'Add Payment Method'; },
    addPaymentMethodWarningDescription: function () {
        return 'Add a payment method for DashPass. You will be charged monthly for each eligible employee.';
    },
    deactivateButton: function () { return 'Deactivate DashPass'; },
    deactivateModalTitle: function () {
        return 'Confirm you want to deactivate DashPass for Work';
    },
    deactivateModalContent1Part1: function () {
        return 'Are you sure you want to deactivate DashPass? ';
    },
    deactivateModalContent1Part2: function (numEmployees) {
        return numEmployees + " " + (numEmployees === 1 ? 'employee' : 'employees');
    },
    deactivateModalContent1Part3: function () {
        return ' will immediately lose access to their DashPass benefits.';
    },
    deactivateModalContent2: function () {
        return "You\u2019ll be charged a prorated rate for the days that DashPass was active this month.";
    },
    deactivateModalConfirmButton: function () { return 'Confirm'; },
    deactivateModalCancelButton: function () { return 'Go Back'; },
    new: function () { return 'New'; },
};
export default DashPassStrings;
